import { 
	ifAuthenticated, 
	ifAuthenticatedOnline,
	canAccess,
	AppTabs,
	Show,
	Edit,
	Create,
	Crud,
	store,
} from '@/router/index'

import Maps from '@/components/common/Maps'
import SendMail from '@/components/common/SendMail'
import Taskboard from '@/components/common/Taskboard'
import CompanyTabs from '@/components/modules/crm/CompanyTabs'
import LeadTabs from '@/components/modules/crm/LeadTabs'
import BusinessDuplicates from '@/components/modules/crm/BusinessDuplicates'
import ProspectTabs from '@/components/modules/crm/ProspectTabs'
import BusinessData from '@/components/modules/crm/BusinessData'
import PricelistIndex from '@/components/modules/crm/PricelistIndex'
import AnalyticsIndex from '@/components/modules/crm/AnalyticsIndex'
import DestinationTabs from '@/components/modules/crm/DestinationTabs'
import PaymentEditor from '@/components/modules/deadlines/PaymentEditor'
import CompanyContactTabs from '@/components/modules/crm/CompanyContactTabs'
import SupplierContactTabs from '@/components/modules/crm/SupplierContactTabs'
import PortalDmsAdminTab from '@/components/modules/portal/PortalDmsAdminTab'

import SupplierTabs from '@/components/modules/products/SupplierTabs'
import SupplierAnalytics from '@/components/modules/products/SupplierAnalytics'
import SupplierEdit from '@/components/modules/crm/SupplierEdit'
import Supplier from '@/components/modules/crm/Supplier'

import LeadsSettings from '@/components/modules/crm/settings/LeadsSettings'
import ProspectsSettings from '@/components/modules/crm/settings/ProspectsSettings'
import IntentsSettings from '@/components/modules/crm/settings/IntentsSettings'
import PaymentsSettings from '@/components/modules/crm/settings/PaymentsSettings'
import SuppliersSettings from '@/components/modules/crm/settings/SuppliersSettings'
import CompaniesSettings from '@/components/modules/crm/settings/CompaniesSettings'
import SimulateMailSchedule from '@/components/modules/crm/settings/SimulateMailSchedule'
import DeadlinesSettings from '@/components/modules/deadlines/settings/DeadlinesSettings'
import ContractcodesSettings from '@/components/modules/crm/settings/ContractcodesSettings'
import CompanyContactsSettings from '@/components/modules/crm/settings/CompanyContactsSettings'
import SupplierContactsSettings from '@/components/modules/crm/settings/SupplierContactsSettings'
import SupplierDeadlinesSettings from '@/components/modules/crm/settings/SupplierDeadlinesSettings'
import CompanyDestinationsSettings from '@/components/modules/crm/settings/CompanyDestinationsSettings'
import SupplierDestinationsSettings from '@/components/modules/crm/settings/SupplierDestinationsSettings'

export const crm = [
	{
		path: '/contractcodes',
		redirect: '/companies/contractcodes'
	},
	{
		path: '/intents',
		redirect: '/companies/intents'
	},
	{
		path: '/companycontacts',
		redirect: '/companies/contacts'
	},
	{
		path: '/deadlines',
		redirect: '/companies/deadlines'
	},
	{
		path: '/suppliercontacts',
		redirect: '/suppliers/contacts'
	},
	{
		path: '/companydestinations',
		redirect: '/companies/destinations'
	},
	{
		path: '/supplierdestinations',
		redirect: '/suppliers/destinations'
	},	

	/**********************************************************************************
	*
	* @CONTACTS
	*
	***********************************************************************************/
	{
		path: '/companies/contacts/create',
		name: 'companycontacts-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'Nuovo'
		},
		props: (route) => ({
			modelDef: 'companycontacts',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/companies/contacts/:id/edit',
		name: 'companycontacts-edit', 
		meta: {
			title: 'Modifica'
		},
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'companycontacts',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/companies/contacts/:id',
		beforeEnter: ifAuthenticated,
		component: CompanyContactTabs, 
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'companycontacts-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show, 
				meta: {
					title: 'companycontacts'
				},				
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'companycontacts',
					modelClass: 'companycontact',
					title: 'companycontacts',
					activities: true,
					fileuploader: true
				}),
			},
			{
				path: '/companies/contacts/:id/taskboard',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('setting', 'contacts_task', next) },
				component: Taskboard,
				meta: {
					title: 'Taskboard'
				},
				props: (route) => ({
					listableId: parseInt(route.params.id),
					listableType: 'companycontact',
				})
			},	
		]
	},
	{
		path: '/suppliers/contacts/create',
		name: 'suppliercontacts-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'Nuovo'
		},
		props: (route) => ({
			modelDef: 'suppliercontacts',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/suppliers/contacts/:id/edit',
		name: 'suppliercontacts-edit', 
		meta: {
			title: 'Modifica'
		},
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'suppliercontacts',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/suppliers/contacts/:id',
		beforeEnter: ifAuthenticated,
		component: SupplierContactTabs, 
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'suppliercontacts-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show, 
				meta: {
					title: 'suppliercontacts'
				},				
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'suppliercontacts',
					modelClass: 'suppliercontact',
					title: 'suppliercontacts',
					activities: true,
					fileuploader: true
				}),
			},
			{
				path: '/suppliers/contacts/:id/taskboard',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('setting', 'contacts_task', next) },
				component: Taskboard,
				meta: {
					title: 'Taskboard'
				},
				props: (route) => ({
					listableId: parseInt(route.params.id),
					listableType: 'suppliercontact',
				})
			},	
		]
	},

	/**********************************************************************************
	*
	* @LEADS
	*
	***********************************************************************************/
	{ 
		path: '/leads',
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/leads/',
					text: 'lead',
				},	
			],
		},
		children: [
			{
				path: '/leads/',
				name: 'leads-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'leads'
				},
				props: {
					modelDef: 'leads',
					actionIcon: 'mdi-account-search-outline',
					title: 'leads',
					styleClass: 'mb-offset'
				}
			},
		],
	},
	{
		path: '/leads-duplicates/',
		name: 'leads-duplicates',
		beforeEnter: ifAuthenticated,
		component: BusinessDuplicates,
		meta: {
			title: 'Lead Duplicati'
		},
		props: {
			title: 'Lead Duplicati',
			styleClass: 'mb-offset',
			modelType: 'lead'
		}
	},
	{
		path: '/leads/:id',
		beforeEnter: ifAuthenticated,
		component: LeadTabs, 
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'leads-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show, 
				meta: {
					title: 'lead'
				},				
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'leads',
					modelClass: 'lead',
					activities: true,
					maillogs: true,
					fileuploader: true,
					calendarEvents: true,
					noteField: 'description'
				}),
			},
			{
				path: '/leads/:id/contacts',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'Contatti'
				},
				props: (route) => ({
					title: 'Contatti',
					modelDef: 'companycontacts',
					actionIcon: 'mdi-account-circle',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/leads/:id/opportunities',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'opportunity', next) },
				component: Crud,
				meta: {
					title: 'opportunities'
				},
				props: (route) => ({
					modelDef: 'opportunities',
					actionIcon: 'work',
					title: 'associated_opportunities',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/leads/:id/quotations',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'quotation', next) },
				component: Crud,
				meta: {
					title: 'Preventivi'
				},
				props: (route) => ({
					modelDef: 'quotations',
					actionIcon: 'library_books',
					title: 'Preventivi',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},		
				})
			},
			{
				path: '/leads/:id/projects',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'project', next) },
				component: Crud,
				meta: {
					title: 'Progetti'
				},
				props: (route) => ({
					modelDef: 'projects',
					actionIcon: 'web',
					title: 'Progetti',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},		
				})
			},
			{
				path: '/leads/:id/assets',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'asset', next) },
				component: Crud,
				meta: {
					title: 'Asset'
				},
				props: (route) => ({
					modelDef: 'assets',
					actionIcon: 'layers',
					title: 'assets',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/leads/:id/taskboard',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('setting', 'leads_task', next) },
				component: Taskboard,
				meta: {
					title: 'Taskboard'
				},
				props: (route) => ({
					listableId: parseInt(route.params.id),
					listableType: 'lead',
				})
			},
		],
	},
	{
		path: '/leads/:id/businessdata',
		name: 'leads-businessdata',
		beforeEnter: ifAuthenticated,
		component: BusinessData,
		meta: {
			title: 'Business Data',
		},
		props: (route) => ({
			id: parseInt(route.params.id),
		})
	},
	{
		path: '/leads/leads-send-mail/:id',
		name: 'leads-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: 'Invio email Lead',
			model_name: 'lead',
			route: 'leads',
			attachmentIncluded: false,
		}),
	},
	{
		path: '/leads/create',
		name: 'leads-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'new_lead'
		},
		props: (route) => ({
			modelDef: 'leads',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/leads/:id/edit',
		name: 'leads-edit', 
		beforeEnter: ifAuthenticatedOnline,
		meta: {
			title: 'edit_lead'
		},
		component: Edit,
		props: (route) => ({
			modelDef: 'leads',
			id: parseInt(route.params.id),
		}),
	},

	/**********************************************************************************
	*
	* @PROSPECTS
	*
	***********************************************************************************/
	{
		path: '/prospects',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/prospects/',
					text: 'prospect',
				},
			],
		},
		children: [
			{
				path: '/prospects/',
				name: 'prospects-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'prospects'
				},
				props: {
					modelDef: 'prospects',
					actionIcon: 'mdi mdi-account-check',
					title: 'prospects',
					styleClass: 'mb-offset'
				}
			},
		],
	},
	{
		path: '/prospects-duplicates/',
		name: 'prospects-duplicates',
		beforeEnter: ifAuthenticated,
		component: BusinessDuplicates,
		meta: {
			title: 'Prospect Duplicati'
		},
		props: {
			title: 'Prospect Duplicati',
			styleClass: 'mb-offset',
			modelType: 'prospect'
		}
	},
	{
		path: '/prospects/:id',
		beforeEnter: ifAuthenticated,
		component: ProspectTabs,
		props: (route) => ({
			id: parseInt(route.params.id)
		}),
		children: [
			{
				path: '',
				name: 'prospects-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'prospect'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'prospects',
					modelClass: 'prospect',
					activities: true,
					maillogs: true,
					fileuploader: true,
					calendarEvents: true,
					noteField: 'description'
				}),
			},
			{
				path: '/prospects/:id/contacts',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'Contatti'
				},
				props: (route) => ({
					title: 'Contatti',
					modelDef: 'companycontacts',
					actionIcon: 'mdi-account-circle',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/prospects/:id/opportunities',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'opportunity', next) },
				component: Crud,
				meta: {
					title: 'opportunities'
				},
				props: (route) => ({
					modelDef: 'opportunities',
					actionIcon: 'work',
					title: 'associated_opportunities',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/prospects/:id/quotations',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'quotation', next) },
				component: Crud,
				meta: {
					title: 'Preventivi'
				},
				props: (route) => ({
					modelDef: 'quotations',
					actionIcon: 'library_books',
					title: 'Preventivi',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/prospects/:id/projects',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'project', next) },
				component: Crud,
				meta: {
					title: 'Progetti'
				},
				props: (route) => ({
					modelDef: 'projects',
					actionIcon: 'web',
					title: 'Progetti',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/prospects/:id/assets',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'asset', next) },
				component: Crud,
				meta: {
					title: 'Asset'
				},
				props: (route) => ({
					modelDef: 'assets',
					actionIcon: 'layers',
					title: 'assets',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/prospects/:id/taskboard',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('setting', 'prospects_task', next) },
				component: Taskboard,
				meta: {
					title: 'Taskboard'
				},
				props: (route) => ({
					listableId: parseInt(route.params.id),
					listableType: 'prospect',
				})
			},
		],
	},
	{
		path: '/prospects/:id/businessdata',
		name: 'prospects-businessdata',
		beforeEnter: ifAuthenticated,
		component: BusinessData,
		meta: {
			title: 'Business Data',
		},
		props: (route) => ({
			id: parseInt(route.params.id),
		})
	},
	{
		path: '/prospects/prospects-send-mail/:id',
		name: 'prospects-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: 'Invio email Prospect',
			model_name: 'prospect',
			route: 'prospects',
			attachmentIncluded: false,
		}),
	},
	{
		path: '/prospects/create',
		name: 'prospects-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'new_prospect'
		},
		props: (route) => ({
			modelDef: 'prospects',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{
		path: '/prospects/:id/edit',
		name: 'prospects-edit',
		beforeEnter: ifAuthenticatedOnline,
		meta: {
			title: 'edit_prospect'
		},
		component: Edit,
		props: (route) => ({
			modelDef: 'prospects',
			id: parseInt(route.params.id),
		}),
	},

	/**********************************************************************************
	*
	* @COMPANIES
	*
	***********************************************************************************/
	{ 
		path: '/companies',
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/companies/',
					text: 'companies',
				},
				{
					to: '/companies/destinations/',
					text: 'companydestinations',
					model: 'companydestination'
				},
				{
					to: '/companies/contacts/',
					text: 'contacts',
					model: 'companycontact'
				},
				{
					to: '/companies/contractcodes/',
					text: 'Codici Appalto',
					model: 'contractcode'
				},
				{
					to: '/companies/deadlines/',
					text: 'Scadenze',
					model: 'companydeadline'
				},
				{
					to: '/companies/payments/',
					text: 'Pagamenti',
					model: 'companypayment'
				},
				{
					to: '/companies/intents/',
					text: 'intents',
					model: 'intent'
				},
			],
		},
		children: [
			{
				path: '/companies/',
				name: 'companies-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'companies'
				},
				props: {
					modelDef: 'companies',
					actionIcon: 'business',
					title: 'companies',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/companies/destinations/',
				name: 'companydestinations-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'companydestinations'
				},
				props: {
					modelDef: 'companydestinations',
					actionIcon: 'place',
					title: 'companydestinations',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/companies/contacts/',
				name: 'companycontacts-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'companycontacts'
				},
				props: {
					modelDef: 'companycontacts',
					actionIcon: 'mdi-account-circle',
					title: 'companycontacts',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/companies/contractcodes/',
				name: 'contractcodes-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'contractcode', next),
				component: Crud,
				meta: {
					title: 'Codici Appalto'
				},
				props: {
					modelDef: 'contractcodes',
					actionIcon: 'mdi-bash',
					title: 'Codici Appalto',
					styleClass: 'mb-offset',
					crudDialog: true,
				}
			},
			{
				path: '/companies/deadlines/',
				name: 'companydeadlines-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'Scadenze Aziende'
				},
				props: {
					modelDef: 'companydeadlines',
					actionIcon: 'mdi-currency-eur',
					title: 'Scadenze Aziende',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/companies/payments/',
				name: 'companypayments-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'Pagamenti'
				},
				props: {
					modelDef: 'companypayments',
					actionIcon: 'mdi-cash-plus',
					title: 'Pagamenti',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/companies/intents/',
				name: 'intents-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'intents',
				},
				props: {
					modelDef: 'intents',
					actionIcon: 'description',
					title: 'intents',
					styleClass: 'mb-offset'
				}
			},
		],
	},
	{
		path: '/companies/:id',
		beforeEnter: ifAuthenticated,
		component: CompanyTabs, 
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'companies-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show, 
				meta: {
					title: 'Azienda'
				},				
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'companies',
					modelClass: 'company',
					activities: true,
					maillogs: true,
					fileuploader: true,
					noteField: 'description'
				}),
			},		
			{
				path: '/companies/:id/destinations',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'companydestinations',
				},
				props: (route) => ({
					title: 'companydestinations',
					modelDef: 'companydestinations',
					actionIcon: 'place',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/pricelists',
				beforeEnter: ifAuthenticated,
				component: PricelistIndex,
				meta: {
					title: 'Listini'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					subFilters: {companies: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/contacts',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'Contatti'
				},
				props: (route) => ({
					title: 'Contatti',
					modelDef: 'companycontacts',
					actionIcon: 'mdi-account-circle',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			// {
			// 	path: '/companies/:id/contractcodes',
			// 	beforeEnter: ifAuthenticated,
			// 	component: Crud,
			// 	meta: {
			// 		title: 'Codici Appalti'
			// 	},
			// 	props: (route) => ({
			// 		title: 'Codici Appalti',
			// 		modelDef: 'contractcodes',
			// 		actionIcon: 'mdi-bash',
			// 		styleClass: 'mb-offset',
			// 		subFilters: {companies: parseInt(route.params.id)},
			// 		defaultInput: {company_id: parseInt(route.params.id)},
			// 	})
			// },
			{
				path: '/companies/:id/deadlines',
				beforeEnter: (to, from, next) => canAccess('permission', 'companydeadline', next),
				component: Crud,
				meta: {
					title: 'Scadenze'
				},
				props: (route) => ({
					modelDef: 'companydeadlines',
					actionIcon: 'mdi-currency-eur',
					title: 'Scadenze Azienda',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
					footerComponent: 'CrudFooter'
				})
			},
			{
				path: '/companies/:id/payments',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'companypayment', next) },
				component: Crud,
				meta: {
					title: 'Pagamenti'
				},
				props: (route) => ({
					modelDef: 'companypayments',
					actionIcon: 'mdi-cash-plus',
					title: 'Pagamenti Azienda',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/analytics',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('setting', 'show_revenue_chart_ddts', next) },
				component: AnalyticsIndex,
				meta: {
					title: 'Statistiche'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				})
			},
			{
				path: '/companies/:id/opportunities',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'opportunity', next) },
				component: Crud,
				meta: {
					title: 'opportunities'
				},
				props: (route) => ({
					modelDef: 'opportunities',
					actionIcon: 'work',
					title: 'associated_opportunities',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/quotations',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'quotation', next) },
				component: Crud,
				meta: {
					title: 'Preventivi'
				},
				props: (route) => ({
					modelDef: 'quotations',
					actionIcon: 'library_books',
					title: 'Preventivi',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},		
				})
			},
			{
				path: '/companies/:id/saleorders',
				beforeEnter: (to, from, next) => canAccess('permission', 'saleorder', next),
				component: Crud,
				meta: {
					title: 'saleorders'
				},
				props: (route) => ({
					modelDef: 'saleorders',
					actionIcon: 'assignment',
					title: 'saleorders',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/ddts',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'ddt', next) },
				component: Crud,
				meta: {
					title: 'DDT'
				},
				props: (route) => ({
					modelDef: 'ddts',
					actionIcon: 'description',
					title: 'DDT',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/invoices',
				beforeEnter: (to, from, next) => canAccess('permission', 'saleinvoice', next),
				component: Crud,
				meta: {
					title: 'saleinvoice'
				},
				props: (route) => ({
					modelDef: 'documents-saleinvoice',
					actionIcon: 'description',
					title: 'saleinvoices',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/creditnotes',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'creditnote', next) },
				component: Crud,
				meta: {
					title: 'Note di Credito'
				},
				props: (route) => ({
					modelDef: 'documents-creditnote',
					actionIcon: 'description',
					title: 'Note di Credito associate',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/subscriptions',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'subscription', next) },
				component: Crud,
				meta: {
					title: 'Abbonamenti'
				},
				props: (route) => ({
					modelDef: 'subscriptions',
					actionIcon: 'payments',
					title: 'Abbonamenti',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},		
				})
			},
			{
				path: '/companies/:id/intents',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'intent', next) },
				component: Crud,
				meta: {
					title: 'intents',
				},
				props: (route) => ({
					modelDef: 'intents',
					actionIcon: 'description',
					title: 'intents',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},							
				})
			},
			{
				path: '/companies/:id/projects',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'project', next) },
				component: Crud,
				meta: {
					title: 'Progetti'
				},
				props: (route) => ({
					modelDef: 'projects',
					actionIcon: 'web',
					title: 'Progetti',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},		
				})
			},
			{
				path: '/companies/:id/assets',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'asset', next) },
				component: Crud,
				meta: {
					title: 'Asset'
				},
				props: (route) => ({
					modelDef: 'assets',
					actionIcon: 'layers',
					title: 'assets',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/credentials',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'credential', next) },
				component: Crud,
				meta: {
					title: 'Credenziali'
				},
				props: (route) => ({
					modelDef: 'credentials',
					actionIcon: 'mdi-key-variant',
					title: 'Credenziali',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/tickets',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'trouble', next) },
				component: Crud,
				meta: {
					title: 'Ticket'
				},
				props: (route) => ({
					modelDef: 'troubles',
					actionIcon: 'receipt',
					title: 'Ticket',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/helpdesk',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'helpdesktrouble', next) },
				component: Crud,
				meta: {
					title: 'Service Desk'
				},
				props: (route) => ({
					modelDef: 'helpdesktroubles',
					actionIcon: 'mdi-face-agent',
					title: 'Service Desk',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/contracts',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'contract', next) },
				component: Crud,
				meta: {
					title: 'Contratti'
				},
				props: (route) => ({
					modelDef: 'contracts',
					actionIcon: 'receipt',
					title: 'contracts',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/helpdeskcontracts',
				beforeEnter: (to, from, next) => canAccess('permission', 'helpdeskcontract', next),
				component: Crud,
				meta: {
					title: 'Contratti'
				},
				props: (route) => ({
					modelDef: 'helpdeskcontracts',
					actionIcon: 'receipt',
					title: 'contracts',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/taskboard',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('setting', 'companies_task', next) },
				component: Taskboard,
				meta: {
					title: 'Taskboard'
				},
				props: (route) => ({
					listableId: parseInt(route.params.id),
					listableType: 'company',
				})
			},
			{
				path: '/companies/:id/portal-users',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'portal', next) },
				component: Crud,
				meta: {
					title: 'Accessi Cliente'
				},
				props: (route) => ({
					title: 'Accessi Cliente',
					modelDef: 'portalusers',
					actionIcon: 'mdi-account-key',
					styleClass: 'mb-offset',
					crudDialog: true,
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/companies/:id/portal-dms',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'portal', next) },
				component: PortalDmsAdminTab,
				meta: {
					title: 'Area Cliente'
				},
				props: (route) => ({
					companyId: parseInt(route.params.id),
				})
			},
		],
	},
	{
		path: '/companies/:id/businessdata',
		name: 'companies-businessdata',
		beforeEnter: ifAuthenticated,
		component: BusinessData,
		meta: {
			title: 'Business Data',
		},
		props: (route) => ({
			id: parseInt(route.params.id),
		})
	},
	{
		path: '/companies/companies-send-mail/:id',
		name: 'companies-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: 'Invio email Cliente',
			model_name: 'company',
			route: 'companies',
			attachmentIncluded: false,
		}),
	},
	{
		path: '/companies/create',
		name: 'companies-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'new_company'
		},
		props: (route) => ({
			modelDef: 'companies',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/companies/:id/edit',
		name: 'companies-edit', 
		beforeEnter: ifAuthenticatedOnline,
		meta: {
			title: 'edit_company'
		},
		component: Edit,
		props: (route) => ({
			modelDef: 'companies',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/settingscompanies/',
		name: 'settingscompanies',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingscompanies/',
					text: 'companies',
				},
				{
					to: '/settingscompanies/companydestinations',
					text: 'companydestinations',
					model: 'companydestination',
				},
				{
					to: '/settingscompanies/companycontacts',
					text: 'Contatti',
					model: 'companycontact'
				},
				{
					to: '/settingscompanies/contractcodes',
					text: 'Codici di Appalto',
					model: 'contractcode'
				},
				{
					to: '/settingscompanies/deadlines',
					text: 'Scadenze',
					model: 'companydeadline'
				},
				{
					to: '/settingscompanies/payments',
					text: 'Pagamenti',
					model: 'companypayment'
				},
				{
					to: '/settingscompanies/intents',
					text: 'Lettere di Intento',
					model: 'intent'
				},
			],
		},
		children: [	
			{
				path: '/settingscompanies/',
				beforeEnter: ifAuthenticatedOnline,
				component: CompaniesSettings,
			},			
			{
				path: '/settingscompanies/companydestinations',
				beforeEnter: ifAuthenticatedOnline,
				component: CompanyDestinationsSettings,
			},
			{
				path: '/settingscompanies/companycontacts',
				beforeEnter: ifAuthenticatedOnline,
				component: CompanyContactsSettings,				
			},	
			{
				path: '/settingscompanies/contractcodes',
				beforeEnter: ifAuthenticatedOnline,
				component: ContractcodesSettings,
			},
			{
				path: '/settingscompanies/deadlines',
				beforeEnter: ifAuthenticatedOnline,
				component: DeadlinesSettings,
			},
			{
				path: '/settingscompanies/payments',
				beforeEnter: ifAuthenticatedOnline,
				component: PaymentsSettings,
			},
			{
				path: '/settingscompanies/intents',
				beforeEnter: ifAuthenticatedOnline,
				component: IntentsSettings,
			},			
		],
	},
	{ 
		path: '/settingscompanies/templates-companyprivacy/create',
		name: 'templates-companyprivacy-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-companyprivacy',
			redirect: route.params.redirect,
			defaultInput: {type: 'companyprivacy'},			
		}),
	},
	{ 
		path: '/settingscompanies/templates-companyprivacy/:id/edit',
		name: 'templates-companyprivacy-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-companyprivacy',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'companyprivacy'},
		}), 
	},
	{ 
		path: '/settingscompanies/templates-companyprivacy/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingscompanies/templates-companyprivacy/' + parseInt(route.params.id) + '/',
					text: 'Template Azienda',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-companyprivacy-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Privacy Azienda'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'templates-companyprivacy',
					modelClass: 'template',
					activities: true
				}), 
			},
		]
	},
	{ 
		path: '/settingscompanies/templates-company/create',
		name: 'templates-company-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'templates-company',
			redirect: route.params.redirect,
			defaultInput: {type: 'company'},			
		}),
	},
	{ 
		path: '/settingscompanies/templates-company/:id/edit',
		name: 'templates-company-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'templates-company',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'company'},
		}), 
	},
	{ 
		path: '/settingscompanies/templates-company/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingscompanies/templates-company/' + parseInt(route.params.id) + '/',
					text: 'Template Azienda',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-company-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Azienda'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'templates-company',
					modelClass: 'template',
					activities: true
				}), 
			},
		]
	},	
	{ 
		path: '/settingscompanies/companiesmailsschedules/create',
		name: 'companiesmailsschedules-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'companiesmailsschedules',
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/settingscompanies/companiesmailsschedules/:id',
		name: 'companiesmailsschedules-show',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'companiesmailsschedules',
			id:  parseInt(route.params.id),
			redirect: {modelDef: 'settingscompaniesscheduling'}
		}), 
	},
	{ 
		path: '/settingscompanies/companiesmailsschedules/:id/simulate',
		name: 'companiesmailsschedules-simulate',
		beforeEnter: ifAuthenticatedOnline,
		component: SimulateMailSchedule,
		props: (route) => ({
			modelDef: 'companiesmailsschedules',
			id:  parseInt(route.params.id),
			redirect: {modelDef: 'settingscompaniesscheduling'}
		}), 
	},
	/**********************************************************************************
	*
	* @DESTINATION
	*
	***********************************************************************************/	
	{
		path: '/companies/destinations/create',
		name: 'companydestinations-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'Nuova'
		},
		props: (route) => ({
			modelDef: 'companydestinations',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/companies/destinations/:id/edit',
		name: 'companydestinations-edit', 
		meta: {
			title: 'Modifica'
		},
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'companydestinations',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/companies/destinations/:id',
		beforeEnter: ifAuthenticated,
		component: DestinationTabs, 
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'companydestinations-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show, 
				meta: {
					title: 'companydestinations'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'companydestinations',
					modelClass: 'companydestination',
					title: 'companydestinations',
					activities: true,
					fileuploader: true
				}),
			},
			{
				path: '/companies/destinations/:id/tickets',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'trouble', next) },
				component: Crud, 
				meta: {
					title: 'Ticket'
				},				
				props: (route) => ({
					modelDef: 'troubles',
					actionIcon: 'location_on',
					title: 'Ticket',
					styleClass: 'mb-offset',
					subFilters: {destinations: parseInt(route.params.id)},
				}),
			},
			{
				path: '/companies/destinations/:id/saleorders',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'saleorder', next) },
				component: Crud, 
				meta: {
					title: 'saleorders'
				},
				props: (route) => ({
					modelDef: 'saleorders',
					actionIcon: 'location_on',
					title: 'saleorders',
					styleClass: 'mb-offset',
					subFilters: {destinations: parseInt(route.params.id)},
					defaultInput: {
						destination_id: parseInt(route.params.id),
						...(route.query.company_id && { company_id: parseInt(route.query.company_id) })
					},
				}),
			},
		]
	},
	/**********************************************************************************
	*
	* @DEADLINES
	*
	***********************************************************************************/		
	{
		path: '/companies/deadlines/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/companies/deadlines/' + parseInt(route.params.id) + '/',
					text: 'Scadenza',
				},
				{
					to: '/companies/deadlines/' + parseInt(route.params.id) + '/payments',
					text: 'Pagamenti',
					model: 'companypayment'
				},
			],
		}),
		children: [
			{
				path: '/companies/deadlines/:id',
				name: 'companydeadlines-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Scadenza'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'companydeadlines',
					modelClass: 'companydeadline',
					activities: true,
					maillogs: true,
					fileuploader: true
				}),
			},
			{
				path: '/companies/deadlines/:id/payments',
				name: 'companydeadlines-payments',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'companypayment', next) },
				component: Crud,
				meta: {
					title: 'Pagamenti'
				},
				props: (route) => ({
					modelDef: 'companypayments',
					actionIcon: 'mdi-cash-multiple',
					title: 'Pagamenti',
					styleClass: 'mb-offset',
					subFilters: {deadlines: parseInt(route.params.id)},
					// "Nuovo" parte da questa scadenza: il pagamento si apre con la sola
					// azienda/fornitore della scadenza compilata (tutte le sue rate aperte
					// in elenco, nessuna preselezionata, importo da inserire)
					defaultInput: {deadline_id: parseInt(route.params.id)},
				}),
			},
		]
	},
	{ 
		path: '/companies/deadlines/:id/edit',
		name: 'companydeadlines-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: {
			title: 'Modifica Scadenza'
		},		
		props: (route) => ({
			modelDef: 'companydeadlines',
			id: parseInt(route.params.id),
		}),
	},
	{ 
		path: '/settingscompanies/templates-companydeadline/create',
		name: 'templates-companydeadline-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'templates-companydeadline',
			redirect: route.params.redirect,
			defaultInput: {type: 'companydeadline'},			
		}),
	},
	{ 
		path: '/settingscompanies/templates-companydeadline/:id/edit',
		name: 'templates-companydeadline-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'templates-companydeadline',
			id: parseInt(route.params.id),
			defaultInput: {type: 'companydeadline'},
		}), 
	},
	{ 
		path: '/settingscompanies/templates-companydeadline/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingscompanies/templates-companydeadline/' + parseInt(route.params.id) + '/',
					text: 'Template Scadenze',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-companydeadline-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'templates-companydeadline',
					modelClass: 'template',
					activities: true
				}), 
			},
		]
	},
	
	/**********************************************************************************
	*
	* @PAYMENTS
	*
	***********************************************************************************/	
	{
		path: '/companies/payments/create',
		name: 'companypayments-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: PaymentEditor,
		meta: {
			title: 'Nuovo Pagamento'
		},
		props: (route) => ({
			modelDef: 'companypayments',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},	
	{ 
		path: '/companies/payments/:id/edit',
		name: 'companypayments-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: PaymentEditor,
		meta: {
			title: 'Modifica Pagamento'
		},		
		props: (route) => ({
			modelDef: 'companypayments',
			id: parseInt(route.params.id),
		}),
	},			
	{
		path: '/companies/payments/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '',
					text: 'Pagamento',
				},
			],
		},
		children: [
			{
				path: '',
				name: 'companypayments-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show, 
				meta: {
					title: 'Pagamento'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'companypayments',
					modelClass: 'companypayment',
					activities: true,
					fileuploader: true
				}),
			},
		]
	},
	{
		path: '/suppliers/payments/create',
		name: 'supplierpayments-create',
		beforeEnter: ifAuthenticatedOnline,
		component: PaymentEditor,
		meta: {
			title: 'Nuovo Pagamento'
		},
		props: (route) => ({
			modelDef: 'supplierpayments',
			deadlinesModelDef: 'supplierdeadlines',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{
		path: '/suppliers/payments/:id/edit',
		name: 'supplierpayments-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: PaymentEditor,
		meta: {
			title: 'Modifica Pagamento'
		},
		props: (route) => ({
			modelDef: 'supplierpayments',
			deadlinesModelDef: 'supplierdeadlines',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/suppliers/payments/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '',
					text: 'Pagamento',
				},
			],
		},
		children: [
			{
				path: '',
				name: 'supplierpayments-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Pagamento'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'supplierpayments',
					modelClass: 'supplierpayment',
					activities: true,
					fileuploader: true
				}),
			},
		]
	},

	/**********************************************************************************
	*
	* @INTENTS
	*
	***********************************************************************************/	
	{
		path: '/intents/create',
		name: 'intents-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'Nuova Lettera Intento'
		},
		props: (route) => ({
			modelDef: 'intents',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/intents/:id/edit',
		name: 'intents-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: {
			title: 'Modifica Lettera Intento'
		},
		props: (route) => ({
			modelDef: 'intents',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/companies/intents/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '',
					text: 'Lettera di Intento',
				},
			],
		},
		children: [
			{
				path: '/companies/intents/:id',
				name: 'intents-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show, 
				meta: {
					title: 'Lettere di Intento'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'intents',
					modelClass: 'intent',
					activities: true,
					fileuploader: true	
				}),
			},
		]
	},

	{ 
		path: '/suppliers', 
		beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'supplier', next) },
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/suppliers/',
					text: 'Fornitori',
				},
				{
					to: '/suppliers/destinations',
					text: 'Destinazioni',
					model: 'supplierdestination'
				},
				{
					to: '/suppliers/contacts',
					text: 'contacts',
					model: 'suppliercontact'
				},
				{
					to: '/suppliers/deadlines/',
					text: 'Scadenze',
					model: 'supplierdeadline'
				},
				{
					to: '/suppliers/payments/',
					text: 'Pagamenti',
					model: 'supplierpayment'
				},
			],
		},
		children: [
			{
				path: '/suppliers/',
				name: 'suppliers-index',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'supplier', next) },
				component: Crud,
				meta: {
					title: 'suppliers'
				},
				props: {
					modelDef: 'suppliers',
					actionIcon: 'store_mall_directory',
					title: 'suppliers',
					styleClass: 'mb-offset'
				}
			},		
			{
				path: '/suppliers/destinations',
				name: 'supplierdestinations-index',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'supplierdestination', next) },
				component: Crud,
				meta: {
					title: 'supplierdestinations'
				},
				props: {
					modelDef: 'supplierdestinations',
					actionIcon: 'place',
					title: 'supplierdestinations',
					styleClass: 'mb-offset',
				}
			},
			{
				path: '/suppliers/contacts',
				name: 'suppliercontacts-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'suppliercontact', next),
				component: Crud,
				meta: {
					title: 'suppliercontacts'
				},
				props: {
					modelDef: 'suppliercontacts',
					actionIcon: 'place',
					title: 'suppliercontacts',
					styleClass: 'mb-offset',
				}
			},
			{
				path: '/suppliers/deadlines/',
				name: 'supplierdeadlines-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'Scadenze Fornitori'
				},
				props: {
					modelDef: 'supplierdeadlines',
					actionIcon: 'mdi-currency-eur',
					title: 'Scadenze Fornitori',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/suppliers/payments/',
				name: 'supplierpayments-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'Pagamenti Fornitori'
				},
				props: {
					modelDef: 'supplierpayments',
					actionIcon: 'mdi-cash-plus',
					title: 'Pagamenti Fornitori',
					styleClass: 'mb-offset'
				}
			},
		],
	},
	{ 
		path: '/suppliers/create',
		name: 'suppliers-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'new_supplier'
		},
		props: (route) => ({
			modelDef:  'suppliers',
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/suppliers/:id/edit',
		name: 'suppliers-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: SupplierEdit,
		meta: {
			title: 'edit_supplier'
		},
		props: (route) => ({
			modelDef:  'suppliers',
			id: parseInt(route.params.id),
		}),
	},
	{ 
		path: '/suppliers/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: SupplierTabs,
		props: (route) => ({
			id: parseInt(route.params.id),
		}),
		children: [
			{
				path: '',
				name: 'suppliers-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Supplier,
				meta: {
					title: 'Fornitore'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
				}),
			},
			{
				path: '/suppliers/:id/destinations',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: 'Destinazioni Fornitore'
				},
				props: (route) => ({
					title: 'Destinazioni Fornitore',
					actionIcon: 'layers',
					modelDef: 'supplierdestinations',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				}),
			},
			{
				path: '/suppliers/:id/contacts',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: 'Contatti Fornitore'
				},
				props: (route) => ({
					title: 'Contatti Fornitore',
					actionIcon: 'mdi-account-circle',
					modelDef: 'suppliercontacts',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				}),
			},
			{
				path: '/suppliers/:id/analytics',
				beforeEnter: ifAuthenticatedOnline,
				component: SupplierAnalytics,
				meta: {
					title: 'Statistiche Fornitori'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
				}),
			},
			{
				path: '/suppliers/:id/deadlines',
				beforeEnter: (to, from, next) => canAccess('permission', 'supplierdeadline', next),
				component: Crud,
				meta: {
					title: 'Scadenze'
				},
				props: (route) => ({
					modelDef: 'supplierdeadlines',
					actionIcon: 'mdi-currency-eur',
					title: 'Scadenze Fornitore',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
					footerComponent: 'CrudFooter'
				})
			},
			{
				path: '/suppliers/:id/payments',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'supplierpayment', next) },
				component: Crud,
				meta: {
					title: 'Pagamenti'
				},
				props: (route) => ({
					modelDef: 'supplierpayments',
					actionIcon: 'mdi-cash-plus',
					title: 'Pagamenti Fornitore',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/suppliers/:id/purchaseddts',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'purchaseddt', next) },
				component: Crud,
				meta: {
					title: 'DDT di Acquisto'
				},
				props: (route) => ({
					modelDef: 'purchaseddts',
					actionIcon: 'description',
					title: 'DDT di Acquisto',
					styleClass: 'mb-offset',
					subFilters: {suppliers: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/suppliers/:id/purchaseinvoices',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'purchaseinvoice', next) },
				component: Crud,
				meta: {
					title: 'Fatture di Acquisto'
				},
				props: (route) => ({
					modelDef: 'documents-purchaseinvoice',
					actionIcon: 'description',
					title: 'Fatture di Acquisto',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
			{
				path: '/suppliers/:id/suppliercreditnotes',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'suppliercreditnote', next) },
				component: Crud,
				meta: {
					title: 'Note di Credito da Fornitore'
				},
				props: (route) => ({
					modelDef: 'documents-suppliercreditnote',
					actionIcon: 'description',
					title: 'Note di Credito da Fornitore',
					styleClass: 'mb-offset',
					subFilters: {companies: parseInt(route.params.id)},
					defaultInput: {company_id: parseInt(route.params.id)},
				})
			},
		{
			path: '/suppliers/:id/purchaseorders',
			beforeEnter: (to, from, next) => canAccess('permission', 'purchaseorder', next),
			component: Crud,
			meta: {
				title: 'Ordini di Acquisto'
			},
			props: (route) => ({
				modelDef: 'purchaseorders',
				actionIcon: 'mdi-cart',
				title: 'Ordini di Acquisto',
				styleClass: 'mb-offset',
				subFilters: {suppliers: parseInt(route.params.id)},
				defaultInput: {company_id: parseInt(route.params.id)},
			})
		},
		{
			path: '/suppliers/:id/portal-users',
			beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'portal', next) },
			component: Crud,
			meta: {
				title: 'Accessi Fornitore'
			},
			props: (route) => ({
				title: 'Accessi Fornitore',
				modelDef: 'portalusers',
				actionIcon: 'mdi-account-key',
				styleClass: 'mb-offset',
				crudDialog: true,
				subFilters: {companies: parseInt(route.params.id)},
				defaultInput: {company_id: parseInt(route.params.id), business_type: 'supplier'},
			})
		},
		{
			path: '/suppliers/:id/portal-dms',
			beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'portal', next) },
			component: PortalDmsAdminTab,
			meta: {
				title: 'Area Fornitore'
			},
			props: (route) => ({
				companyId: parseInt(route.params.id),
			})
		},
		]
	},
	{
		path: '/suppliers/destinations/create',
		name: 'supplierdestinations-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'Nuova Destinazione'
		},
		props: (route) => ({
			modelDef:  'supplierdestinations',
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/suppliers/destinations/:id/edit',
		name: 'supplierdestinations-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: {
			title: 'Modifica Destinazione'
		},		
		props: (route) => ({
			modelDef:  'supplierdestinations',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/suppliers/destinations/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/suppliers/destinations/' + parseInt(route.params.id) + '/',
					text: 'Destinazione Fornitore',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'supplierdestinations-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Fornitore'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'supplierdestinations',
					modelClass: 'supplierdestination',
					activities: true
				}),
				meta: {
					title: 'Destinazione Fornitore'
				},		
			},		
		]
	},

	{
		path: '/suppliers/deadlines/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/suppliers/deadlines/' + parseInt(route.params.id) + '/',
					text: 'Scadenza Fornitore',
				},
				{
					to: '/suppliers/deadlines/' + parseInt(route.params.id) + '/payments',
					text: 'Pagamenti',
					model: 'supplierpayment'
				},
			],
		}),
		children: [
			{
				path: '/suppliers/deadlines/:id',
				name: 'supplierdeadlines-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Scadenza Fornitore'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'supplierdeadlines',
					modelClass: 'supplierdeadline',
					activities: true,
					maillogs: true,
					fileuploader: true
				}),
			},
			{
				path: '/suppliers/deadlines/:id/payments',
				name: 'supplierdeadlines-payments',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'supplierpayment', next) },
				component: Crud,
				meta: {
					title: 'Pagamenti'
				},
				props: (route) => ({
					modelDef: 'supplierpayments',
					actionIcon: 'mdi-cash-multiple',
					title: 'Pagamenti',
					styleClass: 'mb-offset',
					subFilters: {deadlines: parseInt(route.params.id)},
					// "Nuovo" parte da questa scadenza: il pagamento si apre con la sola
					// azienda/fornitore della scadenza compilata (tutte le sue rate aperte
					// in elenco, nessuna preselezionata, importo da inserire)
					defaultInput: {deadline_id: parseInt(route.params.id)},
				}),
			},
		]
	},
	{ 
		path: '/suppliers/deadlines/:id/edit',
		name: 'supplierdeadlines-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: {
			title: 'Modifica Scadenza'
		},		
		props: (route) => ({
			modelDef: 'supplierdeadlines',
			id: parseInt(route.params.id),
		}),
	},
	{ 
		path: '/settingscompanies/templates-supplierdeadline/create',
		name: 'templates-supplierdeadline-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'templates-supplierdeadline',
			redirect: route.params.redirect,
			defaultInput: {type: 'supplierdeadline'},			
		}),
	},	

	{
		path: '/settingssuppliers/',
		name: 'settingssuppliers',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingssuppliers',
					text: 'Fornitori',
				},
				{
					to: '/settingssuppliers/destinations',
					text: 'Destinazioni',
					model: 'supplierdestination'
				},
				{
					to: '/settingssuppliers/contacts',
					text: 'Contatti',
					model: 'suppliercontact'
				},
				{
					to: '/settingssuppliers/deadlines',
					text: 'Scadenze',
					model: 'supplierdeadline'
				},
			],
		},
		children: [
			{
				path: '/settingssuppliers/',
				beforeEnter: ifAuthenticatedOnline,
				component: SuppliersSettings,
			},
			{
				path: '/settingssuppliers/destinations',
				beforeEnter: ifAuthenticatedOnline,
				component: SupplierDestinationsSettings,
			},
			{
				path: '/settingssuppliers/contacts',
				beforeEnter: ifAuthenticatedOnline,
				component: SupplierContactsSettings,
			},
			{
				path: '/settingssuppliers/deadlines',
				beforeEnter: ifAuthenticatedOnline,
				component: SupplierDeadlinesSettings,
			},
		],
	},
	{ 
		path: '/maps',
		name: 'maps', 
		beforeEnter: ifAuthenticatedOnline,
		component: Maps, 
		meta: {
			title: 'Mappe'
		},
		props: (route) => ({
			modelDef: 'companies',
		}),
	},
	/**********************************************************************************
	*
	* @LEAD SETTINGS
	*
	***********************************************************************************/
	{
		path: '/settingsleads/',
		name: 'settingsleads',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsleads/',
					text: 'Leads',
				},
			],
		},
		children: [	
			{
				path: '/settingsleads/',
				beforeEnter: ifAuthenticatedOnline,
				component: LeadsSettings,
			},
		],
	},
	{ 
		path: '/settingsleads/templates-lead/create',
		name: 'templates-lead-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'templates-lead',
			redirect: route.params.redirect,
			defaultInput: {type: 'lead'},			
		}),
	},
	{ 
		path: '/settingsleads/templates-lead/:id/edit',
		name: 'templates-lead-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'templates-lead',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'lead'},
		}), 
	},
	{
		path: '/settingsleads/templates-lead/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/settingsleads/templates-lead/' + parseInt(route.params.id) + '/',
					text: 'Template Lead',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-lead-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Lead'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'templates-lead',
					modelClass: 'template',
					activities: true
				}),
			},
		]
	},

	/**********************************************************************************
	*
	* @PROSPECT SETTINGS
	*
	***********************************************************************************/
	{
		path: '/settingsprospects/',
		name: 'settingsprospects',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsprospects/',
					text: 'Prospects',
				},
			],
		},
		children: [
			{
				path: '/settingsprospects/',
				beforeEnter: ifAuthenticatedOnline,
				component: ProspectsSettings,
			},
		],
	},
	{
		path: '/settingsprospects/templates-prospect/create',
		name: 'templates-prospect-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'templates-prospect',
			redirect: route.params.redirect,
			defaultInput: {type: 'prospect'},
		}),
	},
	{
		path: '/settingsprospects/templates-prospect/:id/edit',
		name: 'templates-prospect-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'templates-prospect',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'prospect'},
		}),
	},
	{
		path: '/settingsprospects/templates-prospect/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/settingsprospects/templates-prospect/' + parseInt(route.params.id) + '/',
					text: 'Template Prospect',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-prospect-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Prospect'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'templates-prospect',
					modelClass: 'template',
					activities: true
				}),
			},
		]
	}
]